module.exports = __webpack_public_path__ + "img/folder-download.6465b33b.svg";